var _defs, _circle, _circle2, _path, _path2, _line, _line2, _line3, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwimSenseBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 250,
    x2: 250,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SwimSense_Big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#5472ea"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    opacity: 0.1,
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.93,267.71V94.27a33,33,0,0,1,33-33h0a33,33,0,0,1,33,33V121",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.37,287.29V120.14c0-14,14.77-33,33-33h0a33,33,0,0,1,33,33v26.73",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 309.64,
    y1: 138.54,
    x2: 348.04,
    y2: 160.23,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 308.87,
    y1: 187.73,
    x2: 347.27,
    y2: 209.43,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 309.64,
    y1: 236.93,
    x2: 348.04,
    y2: 258.62,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381.88,222.37c44.9,30.78,62.44,64.62,61.05,97-4.88,113.74-214.86,156.31-270.34-16.66C151.82,238,51.41,270.42,51.41,207c0-51.92,113.59-65.18,221.71-34.13",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59,225.94s63.88-61.44,209.36-18",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M377.41,263.24s48.12,24.28,58,74.33",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M279,345.6c11,0,11,8.8,22,8.8s11-8.8,22-8.8,11,8.8,22,8.8,11-8.8,22-8.8",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.69,251.56c12.27,0,12.27,7.36,24.54,7.36s12.27-7.36,24.54-7.36,12.27,7.36,24.55,7.36",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimSenseBig);
export default __webpack_public_path__ + "static/media/SwimSense_Big.acf39adfce1ed5fbc5b1e77d1ae10e52.svg";
export { ForwardRef as ReactComponent };